// 这里注册事件
import operations from './operations'
import functions from './functions'

var eventMaps = [
  // login
  {
    id: operations.eRefreshToken,
    func: functions.login.funcRefreshToken
  },
  {
    id: operations.eFetchUserInfo,
    func: functions.login.funcFetchUserInfo
  },

  {
    id: operations.eLogout,
    func: functions.login.funcLogout
  },

  // fs
  {
    id: operations.eFetchFSToken,
    func: functions.fs.funcFetchFSToken
  },
  {
    id: operations.ePutFS,
    func: functions.fs.funcPutFS
  },
  {
    id: operations.ePutFSList,
    func: functions.fs.funcPutFSList
  },
  {
    id: operations.eDelFS,
    func: functions.fs.funcDelFS
  },

  // app
  {
    id: operations.eCreateBottomsByRoles,
    func: functions.app.funcCreateBottomsByRoles
  },
  {
    id: operations.eSelectPageByRole,
    func: functions.app.funcSelectPageByRole
  },
  {
    id: operations.eMapRightsFromRoles,
    func: functions.app.funcMapRightsFromRoles
  },
  {
    id: operations.eChangePage,
    func: functions.app.funcChangePage
  },
  {
    id: operations.eFetchTTSToken,
    func: functions.app.funcFetchTTSToken
  },
  {
    id: operations.eRequestPermissions,
    func: functions.app.funcRequestPermissions
  },
  {
    id: operations.eCheckAPKUpdate,
    func: functions.app.funceCheckAPKUpdate
  },
  {
    id: operations.eEdsFileView,
    func: functions.app.funcEdsFileView
  },
  {
    id: operations.eSetTimer,
    func: functions.app.funcSetTimer
  },

  // router
  {
    id: operations.eRouterBack,
    func: functions.app.funcRouterBack
  },
  {
    id: operations.eRouterReplace,
    func: functions.app.funcRouterReplace
  },

  // JPush
  {
    id: operations.eInitJPush,
    func: functions.JPush.funcInitJPush
  },
  {
    id: operations.eSetJPushAlias,
    func: functions.JPush.funcSetJPushAlias
  },
  {
    id: operations.eDeleteJPushAlias,
    func: functions.JPush.funcDeleteJPushAlias
  },
  {
    id: operations.eSetJPushTags,
    func: functions.JPush.funcSetJPushTags
  },
  {
    id: operations.eSetRecieveNotificationInAndroidCallback,
    func: functions.JPush.funcSetRecieveNotificationInAndroidCallback
  },
  {
    id: operations.eSetRecieveMessageInAndroidCallback,
    func: functions.JPush.funcSetRecieveMessageInAndroidCallback
  },
  {
    id: operations.eOpenNotificationInAndroidCallback,
    func: functions.JPush.funcOpenNotificationInAndroidCallback
  },

  // msgbox
  {
    id: operations.eFetchMsgForBoxBadge,
    func: functions.msgbox.funcFetchMsgForBoxBadge
  },

]

export default eventMaps
